import {
  GET_VAPID_PUBLIC_KEY,
  GET_NOTIFICATIONS,
  MARK_ALL_NOTIFICATIONS_READ,
  MARK_NOTIFICATION_READ,
  SUBSCRIBE_WEB_PUSH,
  NOTIFICATIONS_LOADING,
  NOTIFICATIONS_ERROR,
  ADD_PUSH_NOTIFICATION,
} from "../constants/actionTypes";

const defaultState = {
  vapidPublicKey: null,
  notifications: [],
  isSubscribed: false,
  loading: false,
  error: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case NOTIFICATIONS_LOADING:
      return { ...state, loading: true, error: null };

    case NOTIFICATIONS_ERROR:
      return { ...state, loading: false, error: action.payload };

    case GET_VAPID_PUBLIC_KEY:
      return { ...state, loading: false, vapidPublicKey: action.payload?.public_key || action.payload };

    case GET_NOTIFICATIONS:
      return {
        ...state,
        loading: false,
        notifications: Array.isArray(action.payload) ? action.payload : action.payload?.results || [],
      };

    case MARK_ALL_NOTIFICATIONS_READ:
      return {
        ...state,
        notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
      };

    case MARK_NOTIFICATION_READ:
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          n.id === action.payload ? { ...n, is_read: true } : n
        ),
      };

    case SUBSCRIBE_WEB_PUSH:
      return { ...state, isSubscribed: true };

    case ADD_PUSH_NOTIFICATION:
      return {
        ...state,
        notifications: [action.payload, ...state.notifications],
      };

    default:
      return state;
  }
};
